import { client } from "../client/client";

function generateUniqueId() {
  return Date?.now().toString() + Math?.floor(Math.random() * 1000).toString();
}

export const registerSharesSave = async (
  customerId,
  membershipAmount,
  sharesAmount,
  savingsAmount,
  mobile,
) => {
  const response = await client.post(
    "api/v1/transaction/register-shares-save",
    {
      category: "credit",
      type: "membership",
      ref_number: String(generateUniqueId()),
      note: "Membership registration fees",
      customer_id: customerId,
      membershipAmount: membershipAmount,
      amount: 1000,
      sharesAmount: sharesAmount,
      savingsAmount: savingsAmount,
      phone_number: mobile,
    },
  );

  return response.data;
};

export const hasCompletedMembership = async (id) => {
  try {
    const { data } = await client.get(
      `/api/v1/transaction/has-completed-membership/${id}`,
    );
    return data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const emailEntry = async (payload) => {
  try {
    const { data } = await client.post(
      "/api/v1/customer/register-customer",
      payload,
    );
    return data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const createCustomer = async (payload) => {
  try {
    const { data } = await client.post("/api/v1/customer", payload);
    return data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const createAddressInfo = async (payload) => {
  try {
    const { data } = await client.post("/api/v1/address", payload);
    return data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getCustomers = async (
  limit,
  page,
  fromDate,
  toDate,
  query,
  status,
  location,
) => {
  let url = `/api/v1/customer?page=${page}&limit=${limit}&status=${status}&q=${query}&location=${location}`;

  if (fromDate) {
    url += `&fromDate=${encodeURIComponent(fromDate)}`;
  }

  if (toDate) {
    url += `&toDate=${encodeURIComponent(toDate)}`;
  }

  const response = await client.get(url);
  return response?.data;
};

export const getCustomer = async (id) => {
  const response = await client.get(`/api/v1/customer/${id}`);

  return response?.data;
};

export const getPendingReasons = async (id) => {
  const response = await client.get(`/api/v1/customer/issues/${id}`);

  return response?.data;
};

export const getCustomerAccounts = async (id) => {
  const response = await client.get(`/api/v1/account/admincustomer/${id}`);

  return response?.data;
};

export const getLoanSummary = async (mobile) => {
  try {
    const response = await client?.post("/api/v1/loan/summary", {
      mobile_no: mobile,
    });
    return response?.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getNormaLoanDetails = async (mobile) => {
  try {
    const response = await client.post("/api/v1/loan/summary/guarantor/admin", {
      mobile_no: mobile,
    });
    return response?.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getEmergencyLoanDetails = async (mobile) => {
  try {
    const response = await client.post("/api/v1/loan/summary/emergency/admin", {
      mobile_no: mobile,
    });
    return response?.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getDevelopmentLoanDetails = async (mobile) => {
  try {
    const response = await client.post(
      "/api/v1/loan/summary/development/admin",
      {
        mobile_no: mobile,
      },
    );
    return response?.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getJijengeLoanDetails = async (mobile) => {
  try {
    const response = await client.post("/api/v1/loan/summary/jijenge/admin", {
      mobile_no: mobile,
    });
    return response?.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getflashTransactions = async (customerId, prod_ID, loanCode) => {
  try {
    const response = await client.post("/api/v1/loan/payment_transactions", {
      customer_id: customerId,
      type: "payment_transactions",
      prod_id: prod_ID,
      org_code: process.env.REACT_APP_ORG_CODE,
      loan_code: loanCode,
    });

    return response?.data?.data?.[0]?.payment_data || [];
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getCustomerTransactions = async (accountNumber) => {
  const response = await client.get(
    `/api/v1/transaction/account/${accountNumber}`,
  );

  return response?.data;
};

export const totalSpentByCustomerPerMonth = async (accountNumber) => {
  const response = await client.get(
    `/api/v1/transaction/account/totalspent/${accountNumber}`,
  );

  return response?.data;
};

export const getCustomerSingleAccounts = async (accountId, customerId) => {
  const response = await client.get(
    `/api/v1/account/adminaccount/${accountId}/${customerId}`,
  );

  return response?.data;
};

export const updateCustomer = async (id, payload) => {
  try {
    const response = await client.patch(
      `/api/v1/customer/admin/${id}`,
      payload,
    );
    return response?.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const updateNextOfKin = async (nextOfKinId, payload) => {
  try {
    const response = await client.patch(
      `/api/v1/customer/next-of-kin/${nextOfKinId}`,
      payload,
    );
    return response?.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const adminResetPassword = async (customerId) => {
  try {
    const response = await client.post(
      `/api/v1/customer/${customerId}/adminresetpassword`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const unSuspendMemberAccount = async (customerId) => {
  try {
    const response = await client.post(
      `/api/v1/customer/${customerId}/unsuspend`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const createAccount = async ({
  product_id,
  branch_id,
  customer_id,
  user_id,
}) => {
  try {
    const { data } = await client.post(`/api/v1/account`, {
      product_id,
      branch_id,
      customer_id,
      user_id,
    });
    return data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const createSavingsAccount = async ({
  product_id,
  branch_id,
  customer_id,
  user_id,
}) => {
  try {
    const { data } = await client.post(`/api/v1/account`, {
      product_id,
      branch_id,
      customer_id,
      user_id,
    });
    return data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const temporaryPassword = async ({ email }) => {
  try {
    const { data } = await client.post(`/api/v1/customer/temporary_password`, {
      email,
    });
    return data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const updateCustomerAddress = async (addressId, payload) => {
  try {
    const response = await client.patch(
      `/api/v1/address/${addressId}`,
      payload,
    );
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getAddressInfo = async (payload) => {
  try {
    const { data } = await client.post(`/api/v1/address`, payload);
    return data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const addNextOfKin = async (customerId, payload) => {
  try {
    const response = await client.post(
      `/api/v1/customer/${customerId}/next-of-kin`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const deleteCustomer = async (id) => {
  const response = await client.delete(`/api/v1/customer/${id}`);

  return response.data;
};

export const checkEmailExists = async (email) => {
  try {
    const response = await client.post("/api/v1/customer/check-email", {
      email,
    });
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const registerCustomer = async (payload) => {
  console.log("Payload in registerCustomer:", payload);
  try {
    const response = await client.post(
      "/api/v1/customer/register-customer-email-mobile",
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    console.log("Response:", response.data?.data);
    return response.data?.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const manualTransaction = async (payload) => {
  try {
    const response = await client.post(
      "/api/v1/transaction/manual-transaction",
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    return response.data?.data;
  } catch (error) {
    console.error("Error in manualTransaction:", error);
    throw error?.response?.data || error;
  }
};

export const sharesManualTransaction = async (payload) => {
  try {
    const response = await client.post(
      "/api/v1/transaction/manual-transaction-shares",
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    return response.data?.data;
  } catch (error) {
    console.error("Error in manualTransaction:", error);
    throw error?.response?.data || error;
  }
};

export const updateCustomerStatus = async (id, payload) => {
  try {
    console.log("Updating customer status - ID:", id, "Payload:", payload);
    const response = await client.patch(`/api/v1/customer/${id}`, payload);
    console.log("Response:", response.data);
    return response.data;
  } catch (error) {
    console.error(
      "Error updating customer status:",
      error?.response?.data || error,
    );
    throw error?.response?.data || error;
  }
};

export const suspendCustomer = async (id, status) => {
  const response = await client.patch(`/api/v1/customer/${id}`, { status });

  return response.data;
};

export const addIssue = async ({ customer_id, field_name, reason }) => {
  try {
    const { data } = await client.post(`/api/v1/customer/addissue`, {
      customer_id,
      field_name,
      reason,
    });
    return data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const exportSelectedCustomers = async (type, customers) => {
  const response = await client.post(
    `/api/v1/customer/export/selected?format=${type}`,
    customers,
    { responseType: "arraybuffer" },
  );

  return response.data;
};

export const exportAllCustomers = async (
  type,
  limit,
  page,
  fromDate,
  toDate,
  status,
  location,
  county,
  subCounty,
  q,
) => {
  const params = new URLSearchParams();

  params.append("format", type);
  params.append("limit", Number(limit) || 10);
  params.append("page", Number(page) || 1);

  if (fromDate) params.append("fromDate", new Date(fromDate).toISOString());
  if (toDate) params.append("toDate", new Date(toDate).toISOString());

  if (status) params.append("status", status);
  if (location) params.append("location", location);
  if (county) params.append("county", county);
  if (subCounty) params.append("subCounty", subCounty);
  if (q) params.append("q", q);

  const response = await client.get(
    `api/v1/customer/export?${params.toString()}`,
    {
      headers: {
        "Content-Type": type === "pdf" ? "application/pdf" : "text/csv",
      },
      responseType: "arraybuffer",
    },
  );

  return response?.data;
};

export const uploadKenyaIdImage = async (file) => {
  const formData = new FormData();
  formData.append("file", file);

  try {
    const response = await client.post(
      "/api/v1/kyc-validation/kenya-id",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          accept: "*/*",
        },
      },
    );

    return response?.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response:", error.response.data);
      console.error("Error status:", error.response.status);
      console.error("Error headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    throw error;
  }
};

export const uploadFile = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  try {
    const response = await client.post("/api/v1/file-upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response?.data?.data?.url;
  } catch (error) {
    console.error("Error uploading file:", error);
    throw error;
  }
};

export const suspendAccount = async (payload) => {
  try {
    const { data } = await client.post(`/api/v1/account/suspend`, payload);
    return data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const closeAccount = async (payload) => {
  try {
    const { data } = await client.post(`/api/v1/account/close`, payload);
    return data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};
export const updateUserInfo = async (id, payload) => {
  try {
    const response = await client.patch(`/api/v1/customer/${id}`, payload);

    if (response.status === 200 || response.status === 201) {
      console.log("User info updated successfully", response.data);
      return response.data;
    } else {
      console.error(
        "Failed to update user info",
        response.status,
        response.data,
      );
    }
  } catch (error) {
    console.error("Error updating user info:", error);
    if (error.response) {
      console.error("Backend response:", error.response.data);
    }
  }
};

export const getCountries = async () => {
  const { data } = await client.get("/api/v1/country");
  return data?.data ?? [];
};

export const getCounties = async () => {
  try {
    const response = await client.get("/api/v1/county");
    return response?.data?.data || [];
  } catch (error) {
    console.error("Failed to fetch counties:", error);
  }
};

export const uploadKenyaIdBack = async (file, userId) => {
  try {
    const formData = new FormData();
    formData?.append("file", file);
    if (userId) formData?.append("userId", userId);

    const { data } = await client.post(
      `/api/v1/kyc-validation/kenya-id/back`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    );

    return data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const uploadKenyaIdFront = async (file, userId) => {
  try {
    const formData = new FormData();

    formData?.append("file", file);

    if (userId) formData?.append("userId", userId);

    const { data } = await client.post(
      `/api/v1/kyc-validation/kenya-id`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    );

    return data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const uploadPassport = async (file, userId) => {
  try {
    const formData = new FormData();

    formData?.append("file", file);

    if (userId) formData?.append("userId", userId);

    const { data } = await client.post(
      `/api/v1/kyc-validation/passport`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    );

    return data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};
